import Vue from "vue";
import VueMeta from "vue-meta";
Vue.use(VueMeta);
